<style lang="less" scoped>
  .v-dialog__content {
    /deep/ .v-dialog--scrollable {
      display: inline-block;
    }
    /deep/ .v-dialog {
      position: relative;
      min-height: 500px;
    }
  }
  .content {
    position: absolute;
    top: 50px;
    bottom: 60px;
    padding: 20px;
    overflow: auto;
  }
</style>
<template>
  <v-dialog
    v-model="value"
    v-bind="$attrs"
    class="dialog"
    :fullscreen="fullscreen"
    :hide-overlay="fullscreen"
    scrollable
    transition="dialog-bottom-transition"
  >
    <v-toolbar
      :absolute="fullscreen"
      height="50"
      min-width="100%"
      flat
      color="#f5f5f5"
    >
      <v-toolbar-title>
        <slot name="header">
          {{ title }}
        </slot>
      </v-toolbar-title>
      <v-spacer />
      <v-toolbar-items style="margin-right: -16px">
        <v-btn
          icon
          @click="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div
      class="content"
    >
      <slot />
    </div>

    <v-footer
      height="60"
      absolute
    >
      <v-spacer />
      <v-btn
        v-if="cancelText"
        text
        @click="close"
      >
        {{ cancelText }}
      </v-btn>
      <space />
      <v-btn
        color="primary"
        :loading="inner_loading"
        @click="ok"
      >
        {{ okText }}
      </v-btn>
    </v-footer>

    <VOverlayLoading :value="contentLoading" />
  </v-dialog>
</template>

<script>
  import VOverlayLoading from './v-overlay-loading';

  export default {
    name: "Modal",
    components: { VOverlayLoading },
    inheritAttrs: false,
    props: {
      value: {
        type: Boolean,
        required: true
      },
      title: {
        type: String,
        default: ''
      },
      fullscreen: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      contentLoading: {
        type: Boolean,
        default: false
      },
      okText: {
        type: String,
        default: '确定'
      },
      cancelText: {
        type: String,
        default: '取消'
      }
    },
    // events
    // @ok, @cancel
    data() {
      return {
        inner_loading: false
      }
    },
    watch: {
      loading() {
        if (!this.loading) {
          this.inner_loading = false;
        }
      }
    },
    methods: {
      close() {
        this.$emit('input', false);
        this.$emit('cancel');
      },
      ok() {
        if (this.loading) {
          this.inner_loading = true;
        }
        this.$emit('ok');
      }
    }
  }
</script>
